import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { CalendarioComponent } from './calendario.component';
import { CalendarModule } from 'ion4-calendar';

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    CalendarModule
  ],
  declarations: [
    CalendarioComponent
  ],
  exports: [
    CalendarioComponent
  ],
  entryComponents: [
    CalendarioComponent
  ]
})

export class CalendarioComponentModule {}
